import React from 'react';
import { string, arrayOf, shape, number } from 'prop-types';
import classnames from 'classnames';
import StyledLabel from '../styled-label';
import ActionRow from '../action-row';
import { trackEvent } from '../../lib/tracking';
import Reputation from '../seller-info-label/components/reputation';
import IconFactory from '../icons/factory-builder';
import colornames from '../../lib/colornames';
import { generateKeyToComponent } from '../../utils/validators';

const namespace = 'ui-pdp-seller-reputation';

const SellerReputation = ({ thermometer, title, sellerStatusInfo, action }) => (
  <div className={namespace}>
    {title && <StyledLabel className={`${namespace}__title`} as="h3" {...title} />}
    {sellerStatusInfo &&
      sellerStatusInfo.map(value => (
        <div key={generateKeyToComponent(value)} className={`${namespace}__status`}>
          {value.icon && (
            <figure className={classnames(`${namespace}__icon`, colornames(value.icon))}>
              {IconFactory(value.icon)}
            </figure>
          )}
          <div>
            <StyledLabel className={classnames(`${namespace}__status-title`)} as="h3" {...value.title} />
            <p className={classnames(`${namespace}__status-subtitle`)}>{value.subtitle.text}</p>
          </div>
        </div>
      ))}
    {thermometer && <Reputation className={`${namespace}__reputation`} thermometer={thermometer} />}
    {action && (
      <ActionRow
        className={`${namespace}__action`}
        modifier="secondary"
        label={action.label.text}
        url={action.target}
        onClick={() => trackEvent(action.track)}
      />
    )}
  </div>
);

SellerReputation.propTypes = {
  thermometer: shape({
    rank: number,
    info: arrayOf(
      shape({
        icon: shape({ id: string }),
        subtitle: string,
        title: string,
      }),
    ),
  }),
  title: string,
  action: shape({
    html_target: string,
    label: shape({
      text: string,
      font_size: string,
      color: string,
      font_family: string,
    }),
    action_type: string,
    track: shape({}),
  }),
  sellerStatusInfo: arrayOf(
    shape({
      icon: shape({
        id: string,
        color: string,
      }),
      title: shape({
        text: string,
        color: string,
        font_size: string,
      }),
      subtitle: shape({
        text: string,
      }),
    }),
  ),
};

SellerReputation.defaultProps = {
  thermometer: null,
  title: null,
  action: null,
  sellerStatusInfo: null,
};

export default React.memo(SellerReputation);
